import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Carrier, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
}

export class Carriers {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (slug: string, config: CustomAxiosConfig = {}): Promise<Carrier> => {
    const response = await this.api.get(`/shipping/carriers/${slug}`, config)
    return rawTransform(Carrier)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Carrier>> => {
    const response = await this.api.get('/shipping/carriers', config)
    return paginatedTransform(Carrier)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Carrier> => {
    const response = await this.api.post('/shipping/carriers', data, config)
    return rawTransform(Carrier)(response.data)
  }

  patch = async (slug: string, data: any, config: CustomAxiosConfig = {}): Promise<Carrier> => {
    const response = await this.api.patch(`/shipping/carriers/${slug}`, data, config)
    return rawTransform(Carrier)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: 'shipping/carriers/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, 'carriers.csv')
  }
}
